import cn from 'classnames';
import React__default, { useState, useRef, useMemo, useEffect } from 'react';
import { useBoolean, useIsMobile } from '@sravni/react-utils';
import { normalizeTabs, normalizeTab } from '@sravni/ugc/lib/specialOffers/helpers';
import { OFFERS_TABS_DEFAULT_ORDER } from '@sravni/ugc/lib/specialOffers/lists';
import { BlockListPreloader } from '../../../components/SpecialOffersPreloader/src/Preloader.js';
import { Headings } from './components/Headings/Headings.js';
import { Iframe } from './components/Iframe/Iframe.js';
import { calculatePreloaderItemsCount } from './helpers/calculatePreloaderItemsCount.js';
import { useGenerateSpecialUrl } from './hooks/generateSpecialUrl.js';
import modules_16ab616e from './ultimate-special-offers.module.scss.js';

const UltimateSpecialOffers = ({ headingType = 'popover', heading, horizontalTitle, iframeSrc: propsIframeSrc, isBVersion, onTabChange, abName, tabs: propsTabs = OFFERS_TABS_DEFAULT_ORDER, isWithButtons, insidePopup = false, isNarrowOnDesktop = false, onLoad, setItemsCount: propsSetItemsCount, bonusFilter, maxDesktopVisibleItems = 8, className, activeTab: propsActiveTab, organizationId, onReceivingAvailableTabs, showOneHorizontalTabHeading, isVerticalOnMobile = false, onHeightChange, type = 'common', ...props }) => {
    const tabs = normalizeTabs(propsTabs);
    const propsActiveTabNormalized = propsActiveTab && normalizeTab(propsActiveTab);
    // const isFirstRenderRef = useRef<boolean>(true);
    const [isIframeLoading, setIframeLoading] = useBoolean(true);
    const isMobile = useIsMobile();
    const [itemsCount, setItemsCount] = useState(null);
    const [activeTabType, setActiveTabType] = useState();
    const wrapperRef = useRef(null);
    const firstTab = useMemo(() => {
        return propsActiveTabNormalized ?? tabs?.[0];
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { iframeDomain, iframeSrc, iframeId } = useGenerateSpecialUrl({
        propsIframeSrc,
        params: {
            isBVersion,
            abName,
            isWithButtons,
            isPopup: insidePopup,
            bonusFilter,
            organizationId,
            isVerticalOnMobile,
        },
        firstTab,
        type,
    });
    const depsString = JSON.stringify(tabs);
    useEffect(() => {
        setActiveTabType(propsActiveTabNormalized ?? tabs[0]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [propsActiveTabNormalized, depsString]);
    useEffect(() => {
        if (!activeTabType)
            return;
        onTabChange && onTabChange(activeTabType);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeTabType?.type, activeTabType?.subtype, onTabChange]);
    useEffect(() => {
        const element = wrapperRef?.current;
        if (!element)
            return;
        const resizeObserver = new ResizeObserver(entries => {
            for (const entry of entries) {
                if (entry.borderBoxSize) {
                    onHeightChange && onHeightChange(entry.borderBoxSize[0].blockSize);
                }
            }
        });
        resizeObserver.observe(element);
        return () => resizeObserver.disconnect();
    }, [onHeightChange, iframeSrc]);
    if (!iframeSrc)
        return null;
    const handleLoad = () => {
        setIframeLoading.off();
        onLoad && onLoad();
    };
    const preloaderItemsCount = calculatePreloaderItemsCount({
        activeTabType,
        insidePopup,
        isMobile,
        isNarrowOnDesktop,
        isVerticalOnMobile,
        maxDesktopVisibleItems,
    });
    const handleItemsCount = (count) => {
        setItemsCount(count);
        propsSetItemsCount && propsSetItemsCount(count);
    };
    const handleReceivingAvailableTabs = (tabs) => {
        onReceivingAvailableTabs && onReceivingAvailableTabs(tabs);
    };
    return (React__default.createElement("div", { className: cn(modules_16ab616e.wrapper, className), ref: wrapperRef },
        !!heading && (React__default.createElement(Headings, { type: headingType, heading: heading, tabs: tabs, activeTabType: activeTabType, setActiveTabType: setActiveTabType, horizontalText: horizontalTitle, showOneHorizontalTabHeading: showOneHorizontalTabHeading, isLimitTabsCount: !!organizationId })),
        (isIframeLoading || itemsCount === null) && type !== 'verticalList' && (React__default.createElement(BlockListPreloader, { itemsCount: preloaderItemsCount, isPopup: insidePopup, isVerticalOnMobile: isVerticalOnMobile })),
        React__default.createElement("div", { style: { height: isIframeLoading || itemsCount === null ? '0px' : 'auto', overflow: 'hidden' } },
            React__default.createElement(Iframe, { iframeSrc: iframeSrc, domain: iframeDomain, iframeId: iframeId, onLoad: handleLoad, activeTabType: activeTabType, setItemsCount: handleItemsCount, maxDesktopVisibleItems: maxDesktopVisibleItems, handleReceivingAvailableTabs: handleReceivingAvailableTabs, tabs: tabs, ...props }))));
};

export { UltimateSpecialOffers };
//# sourceMappingURL=UltimateSpecialOffers.js.map
